export default __webpack_public_path__ + "static/hunt-ef6d736dbc75091c4d4eac01c8e044e4.png";